import { Dialog, Transition } from "@headlessui/react"
import { XIcon } from "@heroicons/react/solid"
import React, { Fragment } from "react"
import { useNavigate } from "react-router-dom"
import SubmissionPreview from "./SubmissionPreview"

const SubmissionModal = ({ isOpen, closeModal, currentSubmission }) => {
  const navigate = useNavigate()

  if (!currentSubmission) return null

  const question = {
    title: "Institution Feedback",
    description: "",
    schema: [
      {
        id: "40r20h16e11D58d6t11D8e38e12o9e",
        type: "shorttext",
        heading: "Course Information",
        placeholder: "e.g. Introduction to Biology",
        label: "Course Title",
        maxLength: null,
      },
      {
        id: "64b47o15h28I8e0t31e49s34m1o57n",
        type: "shorttext",
        heading: "",
        placeholder: "e.g. BIO 101",
        label: "Course code",
        maxLength: null,
      },
      {
        id: "3a63i30b35e51r3a6t17117119t5d",
        type: "shorttext",
        heading: "",
        placeholder: "Eg: 2022/2023",
        label: "Academic Session",
        maxLength: null,
      },
      {
        id: "22e18914t21c23N32c12o56i66e49s49s",
        type: "singlechoice",
        label: "Academic semester",
        options: ["1st semester", "2nd semester"],
      },
    ],
  }

  const submission = [
    {
      id: "40r20h16e11D58d6t11D8e38e12o9e",
      answer: "Introduction to Biology",
    },
    {
      id: "64b47o15h28I8e0t31e49s34m1o57n",
      answer: "BIO 101",
    },
    {
      id: "3a63i30b35e51r3a6t17117119t5d",
      answer: "2022",
    },
    {
      id: "22e18914t21c23N32c12o56i66e49s49s",
      answer: "1st semester",
    },
  ]

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={closeModal}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-6 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-xl transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                <div className="flex flex-wrap items-center justify-between  gap-2">
                  <div className="flex flex-col">
                    <Dialog.Title
                      as="h3"
                      className="text-lg font-medium leading-6 text-gray-900"
                    >
                      {currentSubmission.user_id}
                    </Dialog.Title>
                    <span className="text-xs text-gray-500">
                      {currentSubmission.user_type} user, Institution:{" "}
                      {currentSubmission.institution}
                    </span>
                  </div>

                  <button
                    type="button"
                    className="inline-flex justify-center rounded-md border border-transparent bg-black px-4 py-2 text-sm font-medium text-gray-50 hover:bg-gray-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-500 focus-visible:ring-offset-2"
                    onClick={() => {
                      closeModal()
                      navigate("/admin/users/12usygh1yusysi")
                    }}
                  >
                    View Profile
                  </button>
                </div>

                <div>
                    <SubmissionPreview config={question} submission={submission} />
                </div>

                <div className="mt-4">
                  <button
                    type="button"
                    className="inline-flex items-center justify-center gap-2 rounded-md border border-transparent bg-red-600 px-4 py-2 text-sm font-medium text-red-50 hover:bg-red-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2"
                    onClick={() => {
                      closeModal()
                    }}
                  >
                    <XIcon className="h-5" />
                    Close
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}

export default SubmissionModal
